//Create blog post TOC with links
document.addEventListener("DOMContentLoaded", function () {
    const tocList = document.getElementById('toc-list');
    const headings = document.querySelectorAll('.article .article__wrapper .article_content h2, .article .article__wrapper .article_content h3');
    
    // Calculate heights
    const announcementBarHeight = document.querySelector('.announcement-bar')?.offsetHeight || 0;
    const headerHeight = document.querySelector('.shopify-section--header')?.offsetHeight || 0;
    const articleToolbarHeight = document.querySelector('.article__toolbar')?.offsetHeight || 0;

    const customHeaderHeight = announcementBarHeight + headerHeight + articleToolbarHeight;   

    const toc = createToc(headings);
    tocList.appendChild(toc);

    const triggers = document.querySelectorAll('.scroll-trigger');
    triggers.forEach(trigger => {
        trigger.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default link behavior

            const targetId = this.getAttribute('href').substring(1);
            const targetHeading = document.getElementById(targetId);

            if (targetHeading) {
                // Get element position relative to the document
                const elementPosition = targetHeading.getBoundingClientRect().top + window.pageYOffset;

                // Calculate offset position with custom header height
                const offsetPosition = elementPosition - customHeaderHeight;                

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
});

function createToc(headings) {
    const tocFragment = document.createDocumentFragment();
    
    // Create the heading contents section
    const headingContents = document.createElement('div');
    headingContents.classList.add('h4');
    headingContents.innerHTML = `Contents`;
    tocFragment.appendChild(headingContents);
  
    const stack = [{ list: tocFragment, level: 0 }];

    headings.forEach((heading) => {
        if (!heading.id) {
            heading.id = heading.textContent.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
        }

        const level = parseInt(heading.tagName.substring(1));
        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.textContent = heading.textContent;
        link.href = `#${heading.id}`;
        link.classList.add('scroll-trigger');

        listItem.appendChild(link);

        // Manage the nesting of lists
        while (stack.length && stack[stack.length - 1].level >= level) {
            stack.pop();
        }

        const parentList = stack[stack.length - 1].list;
        let subList = parentList.querySelector('ul');
        if (!subList) {
            subList = document.createElement('ul');
            parentList.appendChild(subList);
        }
        subList.appendChild(listItem);
        stack.push({ list: listItem, level: level });
    });
    return tocFragment;
}